import { CHANGE_BAG_TO_CART_COPY_AND_ICON_240719 } from "@faire/web-api/indigofair/settings/CHANGE_BAG_TO_CART_COPY_AND_ICON_240719";

import { useAssignSetting, useSetting } from "./__internal__/useSetting";

export const useSettingChangeBagToCartCopyAndIcon = (): boolean =>
  useSetting(CHANGE_BAG_TO_CART_COPY_AND_ICON_240719, false);

export const useAssignSettingChangeBagToCartCopyAndIcon = () =>
  useAssignSetting(CHANGE_BAG_TO_CART_COPY_AND_ICON_240719);
